import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							Una muestra de lo que he creado 
						</div>

						<div className="subtitle projects-subtitle">
						He hechos avances significativos a lo largo de diversos proyectos en mi trayectoria y me siento muy satisfecho con los resultados obtenidos. Una parte importante de mi trabajo se ha enfocado en proyectos de código abierto, los cuales están disponibles para que otros los exploren y aporten sus contribuciones. Creo firmemente en la potencia de la colaboración para potenciar el crecimiento colectivo, y siempre estoy emocionado por recibir nuevas perspectivas y comentarios constructivos. 
						</div>

						<div className="subtitle projects-subtitle">
							<h4 style={{ fontWeight: 'bold', color: 'black', textDecoration: 'underline'}}>Tecnologías y herramientas con las que he trabajado:</h4>
							<ul >
								<li>JavaScript</li>
								<li>React (Redux Toolkit - React Router)</li>
								<li>Material UI - Bootstrap - CSS</li>
								<li>NodeJS - ExpressJS - APIs - Postman</li>
								<li>Firebase - MongoDB - Cloudinary</li>
								<li>Vite - Yarn - NPM</li>
								<li>Git - GitHub</li>
							</ul> 
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
